module.exports = __webpack_public_path__ + "static/media/RetailPref.acbaedf9.png";